import { render } from "./JadwalKelasPercobaan.vue?vue&type=template&id=2d9d5da4"
import script from "./JadwalKelasPercobaan.vue?vue&type=script&lang=js"
export * from "./JadwalKelasPercobaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__